export default class ElapsedTimer {
  private startTime = 0;
  start() {
    this.startTime = new Date().getTime();
  }
  elapsed() {
    return new Date().getTime() - this.startTime;
  }
}
